import { render } from "./ExchangeReturnRequest.vue?vue&type=template&id=43079222"
import script from "./ExchangeReturnRequest.vue?vue&type=script&lang=js"
export * from "./ExchangeReturnRequest.vue?vue&type=script&lang=js"

import "./ExchangeReturnRequest.vue?vue&type=style&index=0&id=43079222&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__